module.exports = __webpack_public_path__ + "static/male-doctor-checking-posture-young-woman-da1097aef63e9c63bf2ec1df0da4abc0.webp";